import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';

export type GlobalSetSummary = Readonly<{
  id: number;
  channel_version: string | null;
  is_default: boolean;
  filled_global_keys: number;
  applicable_attribute_keys: number;
}>;

export type ChannelSummary = Readonly<{
  channel_name: string;
  global_sets: GlobalSetSummary[];
}>;

export type CommonalityChannelsListData = Readonly<{
  channels: ChannelSummary[];
}>;

type CommonalityChannelsListResponse = Readonly<{
  data: { channels: ChannelSummary[] } | ChannelSummary[];
}>;

export async function getCommonalityChannels(
  scope: RequestScope,
  args: { signal?: AbortSignal } = {},
  options: ReadRequestOptions
): Promise<ChannelApiResponse<CommonalityChannelsListData>> {
  try {
    const res = await scopedChannelApi(scope).get<CommonalityChannelsListResponse>('atts/commonality/global/channels', {
      ...options,
      headers: buildAsturHeaders(),
      signal: args.signal ?? options.signal,
    });

    const raw = res.data?.data;
    if (!raw) {
      throw new Error('Invalid commonality channels response');
    }

    const channels = Array.isArray(raw) ? raw : raw.channels;
    if (!Array.isArray(channels)) {
      throw new Error('Invalid commonality channels response: missing channels[]');
    }

    return {
      data: { channels },
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
